import { __translate } from '../language/translate.js';
export function userlogin() {
	var email = document.getElementById('session_email').value;
	var password = document.getElementById('session_password').value;
	var remember = document.getElementById('session_remember_me').checked;
	$('#session_email').removeClass('is-invalid');
	$('#session_password').removeClass('is-invalid');
	$('.btn-login').attr('disabled', true);
	return new Promise(function (resolve, reject) {
		var json = {};
		json['email'] = email;
		json['password'] = password;
		json['remember'] = remember;
		$.ajax({
			type: 'post',
			dataType: 'json',
			url: '/login',
			data: {data: json},
			success: function (response) {
				location.href = '/';
				resolve(response);
			},
			error: function (response) {
				if (response.status == 401) {
					$('#session_email').addClass('is-invalid');
					$('#session_password').addClass('is-invalid');	
					$('.btn-login').attr('disabled', false);
				}
				if (response.status == 403) {
					location.href = location.href;
				}
				reject(false);
			}
		});
	});
}

export function resetPW() {
	$('#users_password').removeClass('is-invalid');
	$('#users_password_confirmation').removeClass('is-invalid');
	var email = document.getElementById('email').value;
	var password = document.getElementById('users_password').value;
	var password_confirmation = document.getElementById('users_password_confirmation').value;
	return new Promise(function (resolve, reject) {
		var json = {};
		json['email'] = email;
		json['password'] = password;
		json['password_confirmation'] = password_confirmation;
		$.ajax({
			type: 'post',
			dataType: 'json',
			url: '/password_reset',
			data: {data: json},
			success: function (response) {
				resolve(response);
				location.href = response.redirect_to || '/';
			},
			error: function (response) {
				$('#users_password').addClass('is-invalid');
				$('#users_password_confirmation').addClass('is-invalid');	
			    reject(false);
			}
		});
	});
}

export function createUser() {
	$('#signup-password-error').html('');
	$('#signup-email-username-error').html('');
	$('#signup-captcha-error').html('');
	$('#users_email').removeClass('is-invalid');
	$('#users_name').removeClass('is-invalid');
	$('#users_password').removeClass('is-invalid');
	$('#users_password_confirmation').removeClass('is-invalid');
	$('#captcha_answer').removeClass('is-invalid');
	if (!$('#users_password').val() || !$('#users_password_confirmation').val()  || 
		($('#users_password_confirmation').val() && $('#users_password_confirmation').val().length<6) || 
		($('#users_password').val() && $('#users_password').val().length<6) || 
		$('#users_password').val() != $('#users_password_confirmation').val()) {
			$('#users_password').addClass('is-invalid');
			$('#users_password_confirmation').addClass('is-invalid');
			$('#signup-password-error').html(__translate(I18n['signup_password_error']));
		return true;
	}
	if (!$('#users_email').val()) {
		$('#users_email').addClass('is-invalid');
		$('#signup-email-username-error').html(__translate(I18n['signup_email_error']));
		return true;
	}
	if (!$('#users_name').val()) {
		$('#users_name').addClass('is-invalid');
		$('#signup-email-username-error').html(__translate(I18n['signup_username_error']));
		return true;
	}
	if ($('.btn-new-account').hasClass('disable') == false) {
		var username = document.getElementById('users_name').value;
		var email = document.getElementById('users_email').value;
		var password = document.getElementById('users_password').value;
		var currency = document.getElementById('users_currency').value;
		var captcha_answer = document.getElementById('captcha_answer').value;
		$('.btn-new-account').attr('disabled', true);
		return new Promise(function (resolve, reject) {
			var json = {};
			json['email'] = email;
			json['password'] = password;
			json['currency'] = currency;
			json['username'] = username;
			json['captcha_answer'] = captcha_answer;
			$.ajax({
				type: 'post',
				dataType: 'json',
				url: '/signup',
				data: {data: json},
				success: function (response) {
					$('#sign-up-form-wrapper').html("<h3 style='color: white;width: 100%;text-align: center;'>"+__translate(I18n['email_activation_mail'])+'</h3>');
					resolve(response);
				},
				error: function (response) {
					if (response.status == 422) {
						// CAPTCHA validation failed
						$('#captcha_answer').addClass('is-invalid');
						$('#signup-captcha-error').html(__translate(I18n['signup_captcha_error'] || 'Incorrect answer. Please try again.'));
						$('.btn-new-account').attr('disabled', false);
					}
					if (response.status == 401) {
						let validator = response.responseJSON.errors[0];
						if (validator.email) {
							$('#users_email').addClass('is-invalid');
							$('#signup-email-username-error').html(__translate(I18n['signup_email_error']));
						}
						if (validator.password) {
							$('#users_password').addClass('is-invalid');
							$('#users_password_confirmation').addClass('is-invalid');	
							$('#signup-password-error').html(__translate(I18n['signup_password_error']));	
						}
						if (validator.username) {
							$('#users_name').addClass('is-invalid');
							$('#signup-email-username-error').html(__translate(I18n['signup_username_error']));
						}			
					}
					if (response.status == 405) {
						$('#users_email').addClass('is-invalid');
						$('#signup-email-username-error').html(__translate(I18n['signup_email_exists_error']));
					}
					if (response.status == 412) {
						$('#users_email').addClass('is-invalid');
						$('#signup-email-username-error').html(__translate(I18n['signup_email_error']));
					}
					$('.btn-new-account').attr('disabled', false);
					return reject();
				}
			});
		});
	}

}

export function updateProfile() {
	$('#users_password').removeClass('is-invalid');
	$('#users_name').removeClass('is-invalid');
	$('#users_password_confirmation').removeClass('is-invalid');
	$('#users_name').removeClass('is-invalid');

	if (!$('#users_name').val()) {
		$('#users_name').addClass('is-invalid');
		$('#edit-username-error').html(__translate(I18n['signup_username_error']));
		return true;
	}

	if ($('#users_password').val() != $('#users_password_confirmation').val()) {
		$('#users_password').addClass('is-invalid');
		$('#users_password_confirmation').addClass('is-invalid');
		$('#edit-password-error').html(__translate(I18n['signup_password_error']));
	    return true;
	}

	var password = document.getElementById('users_password').value;

	if (!$('#users_password').val()) {
		password = null;	
	}

	var currency = document.getElementById('users_currency').value;
	var username = document.getElementById('users_name').value;

	return new Promise(function (resolve, reject) {
		var json = {};
		json['username'] = username;
		json['currency'] = currency;
		json['password'] = password;
		$.ajax({
			type: 'post',
			dataType: 'json',
			url: '/user_update',
			data: {data: json},
			success: function (response) {
				resolve(response);
				location.href = location.href;
			},
			error: function (response) {
				if (response.status == 401) {
					let validator = response.responseJSON.errors[0];
					if (validator.password) {
						$('#users_password').addClass('is-invalid');
						$('#users_password_confirmation').addClass('is-invalid');	
						$('#edit-password-error').html(__translate(I18n['signup_password_error']));	
					}
					if (validator.username) {
						$('#users_name').addClass('is-invalid');
						$('#edit-username-error').html(__translate(I18n['signup_username_error']));
					}			
				}
				return reject();
			}
		});
	});
}


export function togglePasswordVisibilityForField(fieldId, iconId) {
	const passwordField = document.getElementById(fieldId);
	const icon = document.getElementById(iconId);

	if (!passwordField || !icon) return;

	if (passwordField.type === "password") {
		passwordField.type = "text";
		icon.style.opacity = "1";
	} else {
		passwordField.type = "password";
		icon.style.opacity = "0.4";
	}
}

export function togglePasswordVisibility() {
	togglePasswordVisibilityForField("session_password", "login-password-toggle");
}